import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-12 px-6 lg:px-44">
      <div className="mx-auto">
        <div className="flex flex-col lg:flex-row justify-between items-center lg:items-start gap-10 lg:gap-0">
          {/* 회사 로고/이름 */}
          <div className="text-center lg:text-left">
            <h3 className="text-2xl font-bold text-blue-400 mb-2">KD darts</h3>
            <p className="text-sm text-gray-400 leading-relaxed max-w-xs mx-auto lg:mx-0">
              Detection Acquisition Recognition Tracking & Drone AI Robotics
              Technology Solution
            </p>
          </div>

          {/* 회사 정보 */}
          <div className="flex flex-col text-center lg:text-right space-y-4">
            {/* 회사명 */}
            <span className="font-semibold text-gray-300 text-sm">
              KD darts Co., LTD.
            </span>

            {/* 연락처 */}
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-end gap-2 sm:gap-4 text-sm text-gray-300">
              <a
                href="tel:031-607-3202"
                className="hover:text-blue-400 transition-colors duration-300"
              >
                031-607-3202
              </a>

              {/* 구분 점 — sm 이상에서만 */}
              <div className="hidden sm:block w-1 h-1 bg-gray-500 rounded-full"></div>

              <a
                href="mailto:j_kim@kddarts.co.k"
                className="hover:text-blue-400 transition-colors duration-300 break-all"
              >
                j_kim@kddarts.co.kr
              </a>
            </div>

            {/* 유튜브 */}
            <div className="flex flex-col sm:flex-row items-center sm:justify-end gap-2 mt-4">
              <span className="text-sm text-gray-400">Follow us:</span>
              <a
                href="https://www.youtube.com/@Official_DARTS"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center space-x-2 text-red-500 hover:text-red-400 transition-colors duration-300"
              >
                <svg
                  className="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                </svg>
                <span className="text-sm font-medium">YouTube</span>
              </a>
            </div>
          </div>
        </div>

        {/* 구분선 */}
        <div className="border-t border-gray-700 mt-10 pt-6">
          <p className="text-center text-sm text-gray-400">
            Copyright ©2021 KD darts Co., LTD. All rights reserved
          </p>
        </div>
      </div>
    </footer>
  );
}
